import {
  ResponsiveContainer,
  LineChart,
  CartesianGrid,
  XAxis,
  YAxis,
  Tooltip,
  Legend,
  Line,
} from "recharts";
import { ChartData } from "./types";
import { poChartAltSeriesColors } from "../../lib/poTheme";

interface DataLineChartProps {
  data: ChartData;
}

const COLORS = poChartAltSeriesColors;

export default function DataLineChart({ data }: DataLineChartProps) {
  const xKey = data.xKey ?? data.columns[0];
  const yKeys =
    data.yKeys && data.yKeys.length > 0
      ? data.yKeys
      : data.columns.filter((c) => c !== xKey);

  return (
    <ResponsiveContainer width="100%" height={300}>
      <LineChart data={data.rows as Record<string, unknown>[]}>
        <CartesianGrid strokeDasharray="3 3" />
        <XAxis dataKey={xKey} />
        <YAxis />
        <Tooltip />
        <Legend />
        {yKeys.map((key, i) => (
          <Line
            key={key}
            type="monotone"
            dataKey={key}
            stroke={COLORS[i % COLORS.length]}
          />
        ))}
      </LineChart>
    </ResponsiveContainer>
  );
}
